import React from 'react';
import messages from '../../../../const/messages';
import withClickOutsideOnOverlay from '../../../../hoc/withClickOutsideOnOverlay';
import BasicFormWithValidation from '../../../forms/BasicFormWithValidation';
import {FormWithCancelButton} from '../../../forms/FormWithCancelButton';

class RenameTestConversationForm extends FormWithCancelButton {

    validateConversationName = ({ conversationName: newConversationName }) => {
        const { project, conversationName } = this.props;

        if (!conversationName) {
            return 'Enter conversation name';
        }

        if (newConversationName === conversationName) {
            return null;
        }

        if (project &&
            project.conversations &&
            project.conversations.filter(conversation => conversation.name === newConversationName).length) {
            return messages.conversationAlreadyExists;
        }

        return null;
    }

    ok = ({ conversationName }) => {
        const existingConversationName = this.props.conversationName;

        if (conversationName === existingConversationName) {
            this.cancel();
        } else {
            this.props.renameConversation(conversationName);
            this.props.onClose();
        }
    }

    render() {
        const { conversationName } = this.props;

        return <BasicFormWithValidation
            title="Rename Test Case"
            type="rename"
            hasCloseIcon={true}
            enableActionBtnByDefault={true}
            inputs={[{
                name: 'conversationName',
                label: 'Test Case Name',
                autoFocus: true,
                maxLength: 50,
                maxLengthMsg: `Max test case length: 50 characters`,
                value: conversationName,
                rules: [this.validateConversationName],
                applyOnEnter: true
            }]}
            okButton={{
                label: 'Rename',
                action: this.ok
            }}
            cancelButton={{
                label: 'Cancel',
                action: this.cancel,
            }}
        />;
    }
}

export default withClickOutsideOnOverlay(RenameTestConversationForm);